// =========================================================
// * Vuetify Material Dashboard - v2.1.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vuetify-material-dashboard
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './vuex/vuexStore';
import vuetify from './plugins/vuetify';
import moment from 'moment';
// import VueAnalytics from 'vue-analytics';

// Vue.use(VueAnalytics, {
//   id: 'G-N4X8GDV88X',
//   disabled: () => {
//     return !store.state.cookie.allowCookie;
//   },
//   router,
// });

Vue.config.productionTip = false;

Vue.prototype.$moment = moment;

/**
 * Array prototype: forEachAsync
 * A forEach function which waits for each callback to finish before calling the next callback.
 */
Vue.prototype.$forEachAsync = async function(array, callback) {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array);
  }
};

new Vue({
  router,
  store,
  vuetify,
  moment,
  render: (h) => h(App),
}).$mount('#app');
